<div class="partnership-logos container"
     [class.inverted]="isInverted">
    <span class="partnership-logos__success"
          *ngIf="isSuccess"></span>
    <div class="partnership-logos__client"
         *ngIf="!onlyPartner"
         [class.has-logo]="clientHasLogo">
        <div [style.background-image]="clientLogoAsCssUrl"
             [attr.aria-label]="'Logo $orga$' | transloco: {orga:
    invitation.account.organization_name}"
             class="logo">
        </div>
    </div>
    <div class="partnership-logos__separator"
         *ngIf="!onlyPartner && !onlyClient">
        <span [ngClass]="{'icon-link': iconType === 'link', 'icon-unlink': iconType === 'unlink', 'blue': isSuccess} "
              class="icon icon-link icon-size-25"></span>
    </div>
    <div class="partnership-logos__partner"
         *ngIf="!onlyClient"
         [class.has-logo]="partnerHasLogo">
        <div [style.background-image]="partnerLogoAsCssUrl"
             [attr.aria-label]="'Logo $orga$' | transloco: {orga:
    invitation.extras?.partner?.name}"
             class="logo">
        </div>
    </div>
</div>
